export default RAILS_ASSET_URL("/bossman_barry.webp")
